import { getValidAccessToken } from '../../../lib/supabase';

export async function callPushSubscribe(body: Record<string, unknown>) {
  const accessToken = await getValidAccessToken();
  const supabaseUrl = import.meta.env.VITE_SUPABASE_URL as string | undefined;
  const anonKey = import.meta.env.VITE_SUPABASE_ANON_KEY as string | undefined;

  if (!supabaseUrl || !anonKey) {
    throw new Error('Configuração do Supabase ausente.');
  }

  // fetch direto: evita quirks do functions.invoke com Authorization no iOS.
  const res = await fetch(`${supabaseUrl}/functions/v1/push-subscribe`, {
    method: 'POST',
    headers: {
      'Content-Type': 'application/json',
      apikey: anonKey,
      Authorization: `Bearer ${accessToken}`,
    },
    body: JSON.stringify(body),
  });

  let payload: { error?: string; ok?: boolean } = {};
  try {
    payload = (await res.json()) as { error?: string; ok?: boolean };
  } catch {
    /* ignore */
  }

  if (!res.ok) {
    if (res.status === 401) {
      throw new Error(payload.error || 'Não autorizado. Faça login novamente.');
    }
    if (res.status === 403) {
      throw new Error(payload.error || 'Sem permissão nesta organização.');
    }
    throw new Error(payload.error || `Falha ao registrar notificações (${res.status})`);
  }

  if (payload.error) {
    throw new Error(String(payload.error));
  }

  return payload;
}
